(() => {
  const emoji = /(?:\p{Regional_Indicator}{2}|[#*0-9]\uFE0F?\u20E3|(?:\p{Extended_Pictographic}|\p{Emoji_Presentation})[\uFE0E\uFE0F]?\p{Emoji_Modifier}?[\u{E0020}-\u{E007F}]*(?:\u200D(?:\p{Extended_Pictographic}|\p{Emoji_Presentation})[\uFE0E\uFE0F]?\p{Emoji_Modifier}?)*)/gu;
  const excluded = 'script, style, noscript, template, svg, textarea, input, [contenteditable], .jdgm-star, .rating-star';
  const cleanText = (node) => {
    if (!node.parentElement || node.parentElement.closest(excluded)) return;
    const cleaned = node.data.replace(emoji, (match) => /^[©®™]$/.test(match) ? match : '');
    if (cleaned !== node.data) node.data = cleaned;
  };
  const cleanTree = (root) => {
    if (root.nodeType === Node.TEXT_NODE) return cleanText(root);
    if (root.nodeType !== Node.ELEMENT_NODE || root.matches(excluded)) return;
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    while (walker.nextNode()) cleanText(walker.currentNode);
  };
  cleanTree(document.body);
  new MutationObserver((records) => {
    for (const record of records) {
      if (record.type === 'characterData') cleanText(record.target);
      else record.addedNodes.forEach(cleanTree);
    }
  }).observe(document.body, { childList: true, subtree: true, characterData: true });
})();
